import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useLazyQuery } from '@apollo/client';
import { GET_USER } from 'api';
import { ProfileLayout } from './profileLayout';
import { Loader } from 'tt-ui-lib/core';

export const ProfilePageView = () => {
  const [isFourOhFour, setIsFourOhFour] = useState(false);
  const [userData, setUserData] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { id } = useParams();

  const [getUser] = useLazyQuery(GET_USER);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      if (id) {
        const response = await getUser({ variables: { id: id } });
        if (response?.data?.user) {
          setUserData(response?.data?.user);
        } else {
          setIsFourOhFour(true);
        }
      }
      setIsLoading(false);
    })();
  }, [id]);

  return isLoading ? (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100%',
        borderRadius: '12px',
        background: '#fff',
      }}
    >
      <Loader />
    </div>
  ) : (
    <>
      <ProfileLayout isFourOhFour={isFourOhFour} userData={userData} setUserData={setUserData} />
    </>
  );
};
